import React, {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import reportUtils from "../../../../../utils/report-utils.js";

const resolveSituation = {
  "NOTHING_NEW": 'Regular',
  "DAMAGED": 'Danificado',
  "MISSING": 'Ausente',
  "IRREGULAR": 'Irregular'
}

const ReportContent = ({data, tableColumns}) => {

  useEffect(() => {
    ReportUtils.createExportableTable(null, null, `Vistoria de posto fixo`, "fixed-post-inspection");
  }, [data, tableColumns]);

  const getObservations = (item) => JSON.parse(item.data).map(el => `${el.item}: ${resolveSituation[el.answer]}`).join(" | ");
  const columns = [
    {id: "name", label: "Local", className: "w-[25%]", renderCell: item => item.name},
    {id: "dt_create", label: "Data/hora", className: "w-[9%]", renderCell: item => reportUtils.formatDateTime(item.dt_create)},
    {id: "namewar", label: "Agente", className: "w-[15%] text-center", renderCell: item => item.namewar},
    {id: "observations", label: "Observações", renderCell: getObservations}
  ];
  const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);


  return(
    <>
      {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
          <table id="fixed-post-inspection" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Vistoria de posto fixo">
            <thead className="thead-background">
                <tr className="bg-[#f6f6f6] text-left">
                  {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                </tr>
            </thead>
            <tbody className="bg-white">
                {data.map((element, index) => (
                  <tr key={index}>
                    {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                  </tr>
                ))}
            </tbody>
          </table>

          <div id="chart-tables"/>
    </>
  )
}

export default ReportContent;